<template>
    <v-card outlined v-bind="$attrs">
        <v-card-title :class="['py-1 text-subtitle-1 font-weight-regular', classTitle]" v-if="!hideTitle">
            <slot name="title"><v-icon left :small="small" v-if="icon">{{ icon }}</v-icon> {{ title }}</slot>
            <v-spacer></v-spacer>
            <slot name="tools"></slot>
            <ButtonsCreateIcon @clicked="emit('clickedCreateButton')" v-if="!noBtnCreate" />
        </v-card-title>
        <v-card-text>
            <slot></slot>
        </v-card-text>
    </v-card>
</template>

<script setup>

import { defineProps, defineEmits } from 'vue';

const props = defineProps({
    title: { type: String, required: false },
    hideTitle: { type: Boolean, default: false},
    icon: { type: String, required: false },
    small: { type: Boolean, required: false },
    noBtnCreate: { type: Boolean, default: false },
    classTitle: { type: String, default: 'grey--text text--darken-2 grey lighten-2' },
})

const emit = defineEmits(['clickedCreateButton'])

</script>